import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { selectUser } from '@/auth/stores/auth-slice';
import { useStoreHydration } from '@/common/hooks/use-store-hydration';
import { getDashboardRoute } from '@/common/lib/get-route-by-user-type';
import { useAppSelector } from '@/common/redux/store';
import { onboardingRoutes } from '@/onboarding/constants/routes';
import { useProfile } from '@/profile/hooks/use-profile';

export function AuthLayout() {
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  const { profile, loading: profileLoading, isError: profileError, isConfirmedAbsent } = useProfile({ skip: !user });
  const isHydrated = useStoreHydration();

  useEffect(() => {
    if (!isHydrated || !user) return;

    // Same reasoning as AuthGuard: a transient fetch error is not a confirmed absence — wait for
    // RTK Query to resolve (loaded or 404-confirmed) rather than guessing.
    if (profileLoading || (profileError && !isConfirmedAbsent)) return;

    if (!profile && isConfirmedAbsent) {
      navigate(onboardingRoutes.createProfile);
      return;
    }

    if (profile) {
      navigate(getDashboardRoute(user));
    }
  }, [user, profile, profileLoading, profileError, isConfirmedAbsent, navigate, isHydrated]);

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
